import React from 'react'
import PropTypes from 'prop-types'
import Widget from './widgets/Widget'

const Activity = ({activity, isLeft, endOfBlock, avatar}) => {
  const {
    metadata,
    speech,
    createdAt
  } = activity

  const timestamp = new Date(createdAt)

  const {
    templates,
    attachment
  } = metadata

  let bubbles = []

  if (templates && Array.isArray(templates) && templates.length) {

    bubbles = templates?.map((template, idx) => {
      const { type, payload } = template
      return (
        <Widget
          key ={idx}
          type={type}
          payload={payload}
          avatar={avatar}
          endOfBlock={endOfBlock && !idx}
          isLeft={isLeft}
          createdAt={timestamp}
        />
      )
    }
    )
  }

  if (attachment) {
    const { type, payload } = attachment
    bubbles.push(
      <Widget
        key='0'
        type={type}
        payload={payload}
        avatar={avatar}
        endOfBlock={endOfBlock && !bubbles.length}
        isLeft={isLeft}
        createdAt={timestamp}
      />
    )
  }
  
  if (!bubbles.length){
    bubbles.push(
      <Widget
        key='0'
        type='text'
        payload={{ speech }}
        avatar={avatar}
        endOfBlock={endOfBlock}
        isLeft={isLeft}
        createdAt={timestamp}
      />
    )
  }

  return (
    <>
      {bubbles}
    </>
  )
}

Activity.propTypes = {
  activity: PropTypes.object.isRequired,
  isLeft: PropTypes.bool.isRequired,
  avatar: PropTypes.any,
  endOfBlock: PropTypes.bool
}

export default Activity
